import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// Configuration Management
export const saveOdooConfig = async (config, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}v1/odoo-crm/config`,
      config,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to save Odoo configuration');
  }
};

export const getOdooConfig = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}v1/odoo-crm/config`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to get Odoo configuration');
  }
};

export const updateOdooConfig = async (config, token) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}v1/odoo-crm/config`,
      config,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update Odoo configuration');
  }
};

export const deleteOdooConfig = async (token) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}v1/odoo-crm/config`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete Odoo configuration');
  }
};

// Connection Testing
export const testOdooConnection = async (token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}v1/odoo-crm/test-connection`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Connection test failed');
  }
};

// Contact Data
export const getContactsCount = async (token, criteria = {}) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}v1/odoo-crm/contacts/count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: criteria,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to get contacts count');
  }
};

export const getContactFields = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}v1/odoo-crm/contact-fields`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to get contact fields');
  }
};

// KPI Sync
export const syncKpiWithOdoo = async (kpiId, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}v1/odoo-crm/sync/${kpiId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to sync KPI with Odoo');
  }
};